
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const Community = ({ t }) => {
    const community = t('home:community', {}, { returnObjects: true });
    const SocialItem = ({ item }) => {
        return <li className={'social_item'}>
            <a target={'_blank'} href={item.url}>
                {item.title}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M5.35205 6.16846H17.2009V18.0173" stroke="white" strokeWidth="2"/>
                    <path d="M17.4442 5.92389L5.92383 17.4442" stroke="white" strokeWidth="2"/>
                </svg>
            </a>
        </li>;
    };
    return (<section className={'community'}>
            <div className="container">
                <div className="community_wrapper">
                    <div className="community_media">
                        <picture>
                            {/*<source*/}
                            {/*    media="(max-width: 768px)"*/}
                            {/*    srcSet={`/img/pages/home/attributes/attr_${slide.img}_small.webp`}*/}
                            {/*    type="image/webp"*/}
                            {/*/>*/}
                            <source media="(min-width: 769px)" srcSet={`/img/pages/home/community/community.webp`} type="image/webp"/>
                            {/*<source*/}
                            {/*    media="(max-width: 768px)"*/}
                            {/*    srcSet={`/img/pages/home/attributes/attr_${slide.img}_small.png`}*/}
                            {/*/>*/}
                            <source media="(min-width: 769px)" srcSet={`/img/pages/home/community/community.png`}/>
                            <img src={`/img/pages/home/community/community.png`} alt={`ColdWare Community`} width={578} height={712} className='community_media_img'/>
                        </picture>
                        <div className={'community_media_info'}>
                            <picture>
                                <source media="(max-width: 768px)" srcSet={`/img/pages/home/community/avatars_small.webp`} type="image/webp"/>
                                <source media="(min-width: 769px)" srcSet={`/img/pages/home/community/avatars.webp`} type="image/webp"/>
                                <source media="(max-width: 768px)" srcSet={`/img/pages/home/community/avatars_small.png`}/>
                                <source media="(min-width: 769px)" srcSet={`/img/pages/home/community/avatars.png`}/>
                                <img src={`/img/pages/home/community/avatars.png`} alt={`ColdWare Community`} width={253} height={96} className='avatars'/>
                            </picture>
                            <div className={'community_media_info_description'}>
                                <div className={'description_text'}>
                                    <p>{community.welcome_1}</p>
                                    <p>{community.welcome_2}</p>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                                    <path d="M39.5674 40.7012V24.2445H23.1107" stroke="white" strokeWidth="2"/>
                                    <path d="M39.9076 23.906L23.9072 39.9064" stroke="white" strokeWidth="2"/>
                                    <circle cx="32" cy="32" r="31" stroke="white" strokeWidth="2"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="community_info">
                        <span className={'community_info_label'}>{community.label}</span>
                        <h2 className={'community_info_title'}>{community.title}</h2>
                        <p className={'community_info_description'}>{community.description}</p>
                        <div className="community_info_social">
                            <h3 className={'community_info_social_title'}>{community.social_title}</h3>
                            <ul className={'community_info_social_list'}>
                                {community.social_list.map(item => {
            return <SocialItem key={item.title} item={item}/>;
        })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>);
};
export default Community;

    async function __Next_Translate__getStaticProps__1976335961d__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/Community/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1976335961d__ as getStaticProps }
  